module.exports = __webpack_public_path__ + "2db04eafb163600d5a4bfa4df5e1acad.woff2";